/**
 * 分类 → 菜名 二级下拉数据（供菜谱筛选、配菜新增共用）
 */
import { CATEGORIES } from '@/constants/categories'

export const DISH_CASCADER_PROPS = {
  expandTrigger: 'hover',
  value: 'value',
  label: 'label',
  children: 'children'
}

export function buildDishCascaderOptions(dishes) {
  return CATEGORIES
    .map((cat) => ({
      value: cat.value,
      label: cat.label,
      children: (dishes || [])
        .filter((d) => d.category === cat.value)
        .map((d) => ({
          value: d.id,
          label: d.name
        }))
    }))
    .filter((group) => group.children.length)
}
